import script from "./PracticumPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticumPage.vue?vue&type=script&setup=true&lang=js"

import "./PracticumPage.vue?vue&type=style&index=0&id=0c1c412e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1c412e"]])

export default __exports__